// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__aDClw","loaderClass":"button_loaderClass__1vbMw"};